var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"MU47MpdqhBZK-4-qTSGC2"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const isDev = process.env.NODE_ENV === 'development';

Sentry.init({
  dsn: 'https://90381cfac4634c3eb8083b1012445559@o996606.ingest.sentry.io/5970378',

  enabled: !isDev,
  enableTracing: !isDev,

  // Sample only 20% of transactions to reduce volume and cost
  tracesSampleRate: 0.2,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Capture replays only on errors (no general session recording to reduce noise)
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0,

  // Ignore common browser errors that are not actionable
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    `Can't find variable: ZiteReader`,
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borance
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this.
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // Common browser extension errors
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
    // Network errors that are not actionable
    'Network request failed',
    'NetworkError',
    'Failed to fetch',
    'Load failed',
    'AbortError',
    // ResizeObserver - common non-critical browser error
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    // Next.js chunk loading errors (usually caused by deployments while users are active)
    'ChunkLoadError',
    /Loading chunk [\d]+ failed/,
  ],

  // Ignore errors from third-party scripts
  denyUrls: [
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    // Facebook
    /graph\.facebook\.com/i,
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Google
    /translate\.googleapis\.com/i,
    // Common third-party scripts
    /hotjar\.com/i,
    /googletagmanager\.com/i,
  ],

  beforeSend(event, hint) {
    const error = hint?.originalException;

    // Skip 401/403 errors — these are auth-related, not bugs.
    // The API client rejects with plain objects carrying a `status` property.
    const status = error?.status || error?.response?.status;
    if (status === 401 || status === 403) {
      return null;
    }
    if (error instanceof Error && /status code 40[13]\b/.test(error.message || '')) {
      return null;
    }

    return event;
  },

  // Filter out "Large Render Blocking Asset" performance issues
  // These are expected for Next.js bundles and not actionable
  beforeSendTransaction(event) {
    if (event?.spans) {
      const filteredSpans = event.spans.filter((span) => {
        const isRenderBlocking = span.op === 'resource.link' || span.op === 'resource.script';
        const isLarge = (span.data?.['http.decoded_response_content_length'] || 0) > 500000;
        return !(isRenderBlocking && isLarge);
      });

      return { ...event, spans: filteredSpans };
    }
    return event;
  },

  integrations: [
    new Sentry.Replay({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
});
